import { FadeUp } from "@/components/motion";

export function ManifestoChapter({ chapter, index }) {
  return (
    <FadeUp delay={index * 0.12} className="relative border-t border-ink/10 pt-8">
      <span
        data-testid={`chapter-number-${chapter.n}`}
        className="font-mono text-[11px] tracking-[0.3em] text-gold-dark/80"
      >
        CHAPTER {chapter.n}
      </span>
      <h3 className="mt-4 font-serif text-2xl sm:text-3xl leading-snug">{chapter.title}</h3>
      <p className="mt-4 text-sm leading-relaxed text-stone-600">{chapter.body}</p>
    </FadeUp>
  );
}
